export const SET_COLOR = 'COLOR_PICKER::SET_COLOR';

export function setColor(color) {
    return {
        type: SET_COLOR,
        color,
    };
}
